import { useEffect, useState } from "react";
// import { Link as RouterLink } from "react-router-dom";
import { PlannerLayout } from "../../layouts";
import { Box, Paper, IconButton, Typography, Container } from "@mui/material";
import { Adjust, LaunchRounded, ScatterPlotOutlined } from "@mui/icons-material";
import {
  DataGrid,
  GridColDef,
  GridFilterModel,
  GridRowsProp,
  GridToolbar,
  GridColumnVisibilityModel,
} from "@mui/x-data-grid";
import { LoadingScreen } from "../../ui/components/LoadingScreen";
import { getPlannerUserClients } from "../../api/providers/plannerClientsProviders";

interface Client {
  id: number;
  name: string;
  email: string;
  ticketCount: number;
}

export const ClientsPage = () => {
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState<Client[]>([]);
  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [""],
  });

  useEffect(() => {
    getClients();
  }, []);

  const getClients = async () => {
    try {
      setLoading(true);
      const result = await getPlannerUserClients();
      if (result.ok) {
        setClients(result.data);
      }
    } catch (error) {
      console.error("Error obteniendo los datos del usuario:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns: GridColDef[] = [
    { field: "name", headerName: "Nombre", width: 250 },
    {
      field: "email",
      headerName: "Correo",
      width: 250,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "ticketCount",
      headerName: "Tickets",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <IconButton
          color="secondary"
        // onClick={() => handleOpenEditDialog(params.row)}
        >
          <Adjust sx={{ backgroundColor: "warning.main", borderRadius: "6px", padding: 0.4 }} />
        </IconButton>
      ),
    },
  ];

  const rows: GridRowsProp = clients.map((client) => ({
    id: client.id,
    email: client.email,
    name: client.name,
    ticketCount: client.ticketCount,
  }));

  return (
    <PlannerLayout title="Clientes">
      <Container sx={{ mt: 2, }}>
        <Box sx={{ mb: 2 }}>
          <Typography
            fontSize={40}
            align="left"
          >
            Clientes
          </Typography>
        </Box>
        {loading && <LoadingScreen />}

        <Paper
          sx={{ overflow: "hidden", width: "100%", borderRadius: 2, mt: 1, p: 4 }}
          elevation={6}
        >
          <Box sx={{ mb: 2 }}>
            <Typography
              fontSize={32}
              component="div"
              align="left"
            >
              Todos los compradores
            </Typography>
          </Box>
          <Box sx={{ height: "60vh" }}>
            <DataGrid
              columns={columns}
              rows={rows}
              sx={{ padding: "10px" }}
              slots={{ toolbar: GridToolbar }}
              filterModel={filterModel}
              onFilterModelChange={(newModel) => setFilterModel(newModel)}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterPlaceholder: "Buscar...",
                },
              }}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={(newModel) =>
                setColumnVisibilityModel(newModel)
              }
            />
          </Box>
        </Paper>
      </Container>
    </PlannerLayout>
  );
};
